<div class="view-section">
  <h3 class="view-section-header">Summary</h3>

  @if (isProject) {
    <app-project-relations-container [relations]="project?.relations"
      [backwardRelations]="project?.backwardRelations" [projectType]="project?.projectType.name"
      [projectBusinessUnits]="project?.projectBusinessUnits">
    </app-project-relations-container>
  }

  @if (isStrategy) {
    <app-strategy-relations-container [relations]="project?.relations"
      [backwardRelations]="project?.backwardRelations" [projectType]="project?.projectType.name"
      [projectBusinessUnits]="project?.projectBusinessUnits">
    </app-strategy-relations-container>
  }

  @if (isProgramManagement) {
    <app-program-management-relations-container [relations]="project?.relations"
      [projectType]="project?.projectType.name" [projectBusinessUnits]="project?.projectBusinessUnits">
    </app-program-management-relations-container>
  }

  @if (isWholeSystem) {
    <app-whole-system-relations-container [relations]="project?.relations"
      [backwardRelations]="project?.backwardRelations" [projectType]="project?.projectType.name"
      [projectBusinessUnits]="project?.projectBusinessUnits">
    </app-whole-system-relations-container>
  }

  @if (project?.briefDescription) {
    <div class="col-md-12">
      <h5 class="hub-level-1-label">Brief Description</h5>
      <p class="record-description pr-3" [innerHTML]="project?.briefDescription"></p>
    </div>
  }

  @if (!isWholeSystem && !isProgramManagement && project?.goal && project?.goal.length) {
    <div class="col-md-12">
      <h5 class="hub-level-1-label">Goal</h5>
      <p class="record-description pr-3" [innerHTML]="project.goal"></p>
    </div>
  }

</div>
